import { render, staticRenderFns } from "./CreateAccountWorkflowPage.vue?vue&type=template&id=a91e7a8e&scoped=true"
import script from "./CreateAccountWorkflowPage.vue?vue&type=script&lang=js"
export * from "./CreateAccountWorkflowPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91e7a8e",
  null
  
)

export default component.exports